import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Gift01 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M9.94765 6.82219C9.98888 7.01338 9.93832 7.215 9.80579 7.3527C9.67327 7.4904 9.47929 7.543 9.29521 7.50009C8.62036 7.32844 6.37074 6.7067 5.7356 6.04677C4.95699 5.23776 4.95385 3.92115 5.72851 3.11626C6.50322 2.31131 7.77037 2.31468 8.54893 3.12363C9.17384 3.77294 9.78243 6.12098 9.94765 6.82219ZM9.94765 6.82219C9.90634 7.01345 9.95696 7.21494 10.0895 7.35264C10.222 7.49034 10.4161 7.54287 10.6001 7.50003C11.2749 7.32837 13.5348 6.69602 14.1597 6.04672C14.9382 5.23776 14.9415 3.92115 14.1668 3.1162C13.3921 2.31131 12.125 2.31457 11.3463 3.12357C10.7112 3.78351 10.1128 6.121 9.94765 6.82219ZM2.58182 11.6668H17.4182C17.7395 11.6668 18 11.4063 18 11.085V8.17586C18 7.85454 17.7395 7.59405 17.4182 7.59405H2.58182C2.26049 7.59405 2 7.85453 2 8.17586V11.085C2 11.4063 2.26049 11.6668 2.58182 11.6668ZM16.5455 11.6668V17.4631C16.5455 17.7844 16.285 18.0449 15.9636 18.0449H4.03636C3.71503 18.0449 3.45455 17.7844 3.45455 17.4631V11.6668H16.5455Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Gift01
